import httpClient from '../api/httpClient';

export const login = async ({ username, password }) => {
  const response = await httpClient.post('/api/identity/Auth/Login', { username, password });
  return response.data;
};

export const changePassword = async ({ currentPassword, newPassword, confirmPassword }) => {
  const response = await httpClient.post('/api/identity/Auth/ChangePassword', {
    currentPassword,
    newPassword,
    confirmPassword,
  });
  return response.data;
};

export default {
  login,
  changePassword,
};


